import { Heading } from './Heading'
import { HEADING_SIZE } from './Heading.constants'

export const HeadingPresentation = () => {
  const renderHeading = () =>
    HEADING_SIZE.map(size => (
      <Heading size={size}> Welcome to Everphone Portal</Heading>
    ))

  return (
    <div className="pt-4">
      <Heading size={4}>Header:</Heading>

      {/* *** Header *** */}

      {renderHeading()}
    </div>
  )
}
